webModule.controller('searchQuoteController',
    ['$scope','$rootScope', '$location', '$timeout', 'welcomeEvents', 'routes', '$window','quoteIntegrationConstants','erateSessionVarsService',
        'quoteCreationEvents','quoteIntegrationService','vehicleProductsProcessingService','rateQuoteCoordService',
        function ($scope, $rootScope, $location, $timeout, welcomeEvents, routes, $window, quoteIntegrationConstants, erateSessionVarsService,
                  quoteCreationEvents, quoteIntegrationService, vehicleProductsProcessingService, rateQuoteCoordService) {
        $scope.srchData = '';
        $scope.disableNew = false;

        $scope.$on(quoteCreationEvents.startNewProductQuote, function(event, args) {
            $scope.closeNewQuote();
        });

        $scope.menuQuoteIntegrated = quoteIntegrationConstants.menuQuoteIntegrated;
        $scope.menuContractIntegrated = quoteIntegrationConstants.menuContractIntegrated;

        $scope.issrchRVEligible = false;
        $scope.issrchAutoEligible = true;

        $scope.searchBarActive = false;

        $scope.closeSearchBar = function () {
            $scope.searchBarActive = false;
        };

        $scope.toggleSearchBar = function () {
            $scope.searchBarActive = !$scope.searchBarActive;
        };
        $scope.goToSearch = function(srchval){
            //make sure we clear everything out to prevent having stale data
            vehicleProductsProcessingService.clearRateSummaryDataAndProducts();
            rateQuoteCoordService.clearAll();
            quoteIntegrationService.clearIntegrationData();

            $scope.srchData = srchval;
            $location.path(routes.search);
            //broadcasting the change to the search controller, but waiting until the controller is loaded (listener needs to be registered before the broadcast is done)
            $timeout(function () {
                //broadcast will available to every listener
                $rootScope.$broadcast(welcomeEvents.welcomeFindTransaction, $scope.srchData);
            }, 500);
            $scope.searchBarActive = false;
        };

        $scope.attemptGoToSearch = function (srchdat) {
            if(angular.element($window).width() < 600){
                if($scope.searchBarActive){
                    $scope.goToSearch(srchdat);
                } else{
                    $scope.toggleSearchBar();
                }
            }  else   {
                $scope.searchBarActive = false;
                $scope.goToSearch(srchdat);
            }
        };

        $scope.openNewRvOrCar = function($event) {
            var popupCaller = $event.currentTarget.getAttribute('popup-click-id'),
                popupTarget = document.querySelectorAll('[popop-target-id="'+popupCaller+'"]'),
                popupTarget = popupTarget[0],
                popupIsShowing = popupTarget.classList.contains('select-popup-open');

            if(popupIsShowing === false) {
                openPopup();
                $timeout(handleClickOne, 10);
            }

            function handleClickOne() {
                window.addEventListener('click', handleClickTwo);
            }

            function handleClickTwo() {
                closePopup();
                window.removeEventListener('click', handleClickTwo);
            }

            function openPopup() {
                popupTarget.classList.remove('select-popup-closed');
                popupTarget.classList.add('select-popup-open');
                popupIsShowing = true;
                //console.log('Popup is open. and var popupIsShowing  === ' + popupIsShowing);
            }

            function closePopup() {
                popupTarget.classList.remove('select-popup-open');
                popupTarget.classList.add('select-popup-closed');
                popupIsShowing = false;
                //console.log('Popup is closed. and var popupIsShowing  === ' + popupIsShowing);
            }

        };

        $scope.init = function(){
            var vType = erateSessionVarsService.getCurrentDealerVehicleType();
            if (vType == null) {vType = 'AUTO';}
            $scope.issrchRVEligible = (vType == 'RV' || vType == 'RVAUTO') ? true : false
            $scope.issrchAutoEligible = (vType == 'AUTO' || vType == 'RVAUTO') ? true : false
        }

        //vehicle data changed, so mark us as "vehicle not ready"
        $scope.$on(quoteCreationEvents.productDataComplete, function(event, args) {
            $scope.disableNew = !vehicleProductsProcessingService.productData.haveProducts;
        });

        $scope.init();
    }]);
